import {EntityType} from "../gd/const/item";
import ErrorProto from "../gd/validation/error";
import {ModelInterface} from "../data-structures/collection";
import {encodeRID} from "./rid";
import {TaskAccessControl} from "./task/access-control/access-control";

export type ModelOptions = {
    useProxy?   : boolean
}

export default class ModelEntity implements ModelInterface {

    // DO NOT ENABLE THIS IT WILL BREAK THINGS !!!
    // Constructor will REDICLARATE THIS
    // public id           : string    = ''
    // public rid          : string    = ''
    // public itemType     : number | null = null


    public id           : ID
    public rid          : RID
    public itemType     : EntityType

    customFieldsData    : any
    sortPosition?       : number | null

    public updatedFields: Set<string>

    constructor(id: string, itemType:EntityType = EntityType.DYNAMIC_MODEL) {

        this.id             = id
        this.itemType       = itemType
        this.rid            = this.initRID(itemType, id)

        this.updatedFields  = new Set()

        // this error disabled as we now create models when insert
        // if (!this.id) {
        //     console.error("ERROR #MODEL-1 No ID passed")
        // }

        if (this.itemType && !this.rid) {
            console.error("ERROR #MODEL-2 No RID passed")
        }

    }

    get acl():any {
        return {}
    }

    protected initRID(itemType:EntityType, id:string|number|ID) : RID {
        return encodeRID(itemType, id as ID)
    }

    // entity type is right name now
    get entityType():EntityType {
        return this.itemType
    }

    // default
    // get isOpen() {
    //     return true
    // }
    //
    // get isClosed() {
    //     return false
    // }

    applyDelta(data:any):boolean {
        // console.blue(10, "model apply delta")
        // console.log(data)


        _.forOwn(data, (value ,key)=>{
            if (key === 'id') return;

            // console.log("update key=", key, "value=", value)
            // console.log("this=", this);

            // console.log(key, value)

            // @ts-ignore
            this[key] =  value;
        });

        return true
    }

    public validate():ErrorProto[] | null {
        return null
    }

    public save(updateParameters?: any) {
        throw Error("#039474 not implemented ")
    }

    public setCustomFieldValue(fieldId:string, value:any) {
        throw Error("#03339474 not implemented")
    }

    quickSearch(quickSearchValue:string):boolean {

        // return false if doesnt match
        // return true if matches

        console.warn("#dkjdhd not implemented")
        return true
    }

    // just use this.updatedFeilds.clear();
    // resetUpdatedFields() {
    //     this.updatedFields = new Set();
    // }

    toJSON(): JSONObject {
        console.error("#48933d475 not implemented")
        return {}
    }

    // openItemView / open item ... etc.
    goTo() {
        throw Error("Not implemented #039382723")
    }

}
